/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronDown, ChevronUp, Search, Plus, RotateCw } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { Link, useLocation } from 'react-router-dom'
import Select from 'react-select'
import RowEmpty from '../../../components/atoms/RowEmpty'
import { BadgeStatusOutboundPlan } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import ModalAddSelectStagingArea from '../../../components/modal/Outbound/ModalAddSelectStagingArea'
import api from '../../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime
} from '../../../helpers/constants'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import * as Common from '../../../utils/Common'

const STATUSES = [
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'waiting_pnp', label: 'Waiting PNP' },
  { value: 'pnp_picking', label: 'PNP Picking' },
  { value: 'waiting_om', label: 'Waiting OM' },
  { value: 'waiting_rnr', label: 'Waiting RNR' },
  { value: 'rnr', label: 'RNR' },
  { value: 'request_loading', label: 'Request Loading' },
  { value: 'loading', label: 'Loading' },
  { value: 'finish_loading', label: 'Finish Loading' },
  { value: 'on_delivery', label: 'On Delivery' },
  { value: 'done', label: 'Done' },
  { value: 'cancel', label: 'Cancel' }
]

const btnCreateSjStyle = {
  color: 'white',
  backgroundColor: '#f89d1d',
  border: 'none',
  borderRadius: '50rem',
  boxShadow: '0 4px 6px rgba(248, 157, 29, 0.2)'
}

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const OutboundPlan = () => {
  const { state } = useLocation()
  const [outboundPlans, setOutboundPlans] = useState([])
  const [selectedWarehouseId, setSelectedWarehouseId] = useState({
    id: 0,
    warehouse_id: 0
  })
  const [filter, setFilter] = useState({
    outbound: state?.outbound || '',
    warehouse_id: state?.warehouse_id || '',
    status: state?.status || '',
    start_date: state?.start_date || '',
    end_date: state?.end_date || ''
  })
  const [debouncedOutbound, setDebouncedOutbound] = useState(filter.outbound)

  const [warehouses, setWarehouses] = useState([])
  const [loadingData, setLoadingData] = useState(false)
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const { per_page, current_page } = meta
  const [modalShowSelectStagingArea, setModalShowSelectStagingArea] =
    useState(false)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedOutbound(filter.outbound)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.outbound])

  const handleOnChangeMeta = (e) => {
    setLoadingData(true)
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
    setLoadingData(false)
  }

  const handlePageChange = (data) => {
    setLoadingData(true)
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
    setLoadingData(false)
  }

  const handleShowModalStagingArea = (id, warehouse_id) => {
    setModalShowSelectStagingArea(true)
    setSelectedWarehouseId({ id, warehouse_id })
  }

  const handleFilterChange = (name, value) => {
    setFilter((prev) => {
      const newFilter = { ...prev, [name]: value }
      if (name === 'start_date' && value && prev.end_date) {
        if (new Date(value) > new Date(prev.end_date)) {
          newFilter.end_date = value
        }
      } else if (name === 'end_date' && value && prev.start_date) {
        if (new Date(value) < new Date(prev.start_date)) {
          newFilter.start_date = value
        }
      }
      return newFilter
    })
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const getOutboundPlans = async (page = null) => {
    try {
      setLoadingData(true)
      const res = await api.get('/outbound/outbound_plan/list', {
        params: {
          per_page,
          page: page ?? current_page,
          outbound: debouncedOutbound,
          warehouse_id: filter.warehouse_id,
          status: filter.status,
          start_date: filter?.start_date
            ? convertDateWithTime(filter?.start_date, 'YYYY-MM-DD')
            : '',
          end_date: filter?.end_date
            ? convertDateWithTime(filter?.end_date, 'YYYY-MM-DD')
            : ''
        }
      })
      if (res.status === 200) {
        const { data, metadata } = res.data
        setOutboundPlans(data)
        setMeta(metadata)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingData(false)
    }
  }

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: 1,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      setWarehouses(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  useEffect(() => {
    getOutboundPlans()
  }, [
    per_page,
    current_page,
    debouncedOutbound,
    filter.warehouse_id,
    filter.status,
    filter.start_date,
    filter.end_date
  ])

  useEffect(() => {
    if (!warehouses.length) {
      fetchWarehouse()
    }
    const timeoutScroll = setTimeout(() => window.scrollTo(0, 0), 0)
    return () => {
      clearTimeout(timeoutScroll)
    }
  }, [])

  const handleReset = () => {
    setFilter({
      outbound: '',
      warehouse_id: '',
      status: '',
      start_date: '',
      end_date: ''
    })
    setDebouncedOutbound('')
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const warehouseOptions = [
    { value: '', label: 'All Warehouses' },
    ...warehouses.map((w) => ({ value: w.id, label: w.warehouse_name }))
  ]

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    ...STATUSES.map((s) => ({ value: s.value, label: s.label }))
  ]

  return (
    <>
      <div className="container-fluid px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 style={headerTitleStyle}>Outbound Plan</h3>
          </Col>
          <Col className="text-end">
            <Link
              to="/outbound/plan/create"
              className="text-decoration-none me-2"
            >
              <button
                className="btn btn-primary-orange rounded px-4 fw-bold"
                style={{
                  ...btnCreateSjStyle,
                  fontSize: '0.85rem',
                  height: '37px'
                }}
              >
                <Plus size={16} className="me-2" />
                Create Outbound
              </button>
            </Link>
            <Button
              variant="light"
              className="text-secondary fw-bold rounded px-3 border"
              onClick={handleReset}
              style={{ fontSize: '0.85rem', height: '37px' }}
            >
              <RotateCw size={16} className="me-2" />
              Reset Filters
            </Button>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Outbound</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={18} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search Outbound Code"
                    id="outbound"
                    name="outbound"
                    onChange={(e) =>
                      setFilter((prev) => ({
                        ...prev,
                        outbound: e.target.value
                      }))
                    }
                    value={filter.outbound}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Warehouse</Form.Label>
                <Select
                  name="warehouse_id"
                  id="warehouse_id"
                  onChange={(e) =>
                    handleFilterChange('warehouse_id', e?.value || '')
                  }
                  value={warehouseOptions.find(
                    (o) => o.value === filter.warehouse_id
                  )}
                  options={warehouseOptions}
                  styles={SelectStyles}
                  placeholder="All Warehouses"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label style={labelStyle}>Status</Form.Label>
                <Select
                  name="status"
                  id="status"
                  onChange={(e) => handleFilterChange('status', e?.value || '')}
                  value={statusOptions.find((o) => o.value === filter.status)}
                  options={statusOptions}
                  styles={SelectStyles}
                  placeholder="All Statuses"
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.start_date}
                    onChange={(date) => handleFilterChange('start_date', date)}
                    maxDate={filter.end_date ? new Date(filter.end_date) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.end_date}
                    onChange={(date) => handleFilterChange('end_date', date)}
                    minDate={
                      filter.start_date ? new Date(filter.start_date) : null
                    }
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-4">
          <Col xs={12}>
            <Table
              hover
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #Outbound
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Source Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Delivery Type
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Driver
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Car
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Delivery Date
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Staging Area
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Status
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={{ ...tableHeaderStyle, width: '8%' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {loadingData && (
                  <tr>
                    <td colSpan={9} className="text-center p-5">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loadingData && outboundPlans.length === 0 && (
                  <RowEmpty colSpan={9} />
                )}
                {!loadingData &&
                  outboundPlans.length > 0 &&
                  outboundPlans.map((value, index) => (
                    <RowData
                      key={index}
                      data={value}
                      showModalStagingArea={handleShowModalStagingArea}
                      stateValue={filter}
                    />
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={9}>
                    <TablePagination
                      meta={meta}
                      handleOnChangeMeta={handleOnChangeMeta}
                      handlePageChange={handlePageChange}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </div>
      <ModalAddSelectStagingArea
        show={modalShowSelectStagingArea}
        onHide={() => {
          setModalShowSelectStagingArea(false)
        }}
        warehouseId={selectedWarehouseId}
        refreshData={() => getOutboundPlans()}
      />
    </>
  )
}

function RowData({ data, showModalStagingArea, stateValue }) {
  const [openSearch, setOpenSearch] = useState(false)
  let urlDetail = `/outbound/plan/detail/${data.id}`
  const propsStaging = (value, showModalStagingArea) => {
    if (value.delivery_type === 'pick_up' && value.status === 'unassigned') {
      return {
        onClick: () => {
          setOpenSearch(!openSearch)
          showModalStagingArea(data.id, data.warehouse_id)
        },
        className: 'd-flex pe-auto',
        role: 'button'
      }
    }
    if (
      value.status === 'unassigned' &&
      value.car !== '-' &&
      value.driver !== '-'
    ) {
      return {
        onClick: () => {
          setOpenSearch(!openSearch)
          showModalStagingArea(data.id, data.warehouse_id)
        },
        className: 'd-flex pe-auto',
        role: 'button'
      }
    }
    return { className: 'd-flex' }
  }
  return (
    <tr key={data.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
      <td className="p-2 align-middle fw-semibold text-primary">
        {data.outbound}
      </td>
      <td className="p-2 align-middle">{data.source}</td>
      <td className="p-2 align-middle">
        {!data?.delivery_type
          ? '-'
          : firstLetterUpperCase(
              data?.delivery_type === 'pick_up'
                ? 'Pick Up'
                : data?.delivery_type
            )}
      </td>
      <td className="p-2 align-middle">{!data.driver ? '-' : data.driver}</td>
      <td className="p-2 align-middle">{!data.car ? '-' : data.car}</td>
      <td className="p-2 align-middle">
        {data.delivery_date ? convertDateWithoutTime(data.delivery_date) : '-'}
      </td>
      <td className="p-2 align-middle">
        <div {...propsStaging(data, showModalStagingArea)}>
          {!data.staging_name ? (
            <span>Select Staging Area</span>
          ) : (
            <>
              <OverlayTrigger
                trigger={['hover', 'click']}
                key={'bottom'}
                placement={'bottom'}
                overlay={
                  <Popover id={`popover-positioned-bottom`}>
                    <Popover.Body>
                      <p>{data.staging_name}</p>
                    </Popover.Body>
                  </Popover>
                }
              >
                <p
                  className="text-truncate mt-3 mb-0"
                  style={{ maxWidth: '150px' }}
                >
                  {data.staging_name}
                </p>
              </OverlayTrigger>
            </>
          )}
          {!data.staging_name &&
            data.driver !== '-' &&
            data.car !== '-' &&
            data.delivery_type !== 'pick_up' &&
            (openSearch ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
          {!data.staging_name &&
            data.delivery_type === 'pick_up' &&
            (openSearch ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
        </div>
      </td>
      <td className="text-end p-2 align-middle">
        {<BadgeStatusOutboundPlan text={data.status} />}
      </td>
      <td className="p-2 align-middle text-end">
        <TableAction>
          <Link to={urlDetail} state={stateValue}>
            <button
              className="btn btn-light text-secondary border rounded shadow-sm"
              style={{
                width: '35px',
                height: '35px',
                padding: 0
              }}
            >
              <Search size={16} />
            </button>
          </Link>
        </TableAction>
      </td>
    </tr>
  )
}

export default OutboundPlan
